import { render, staticRenderFns } from "./ListaRilevazioni.vue?vue&type=template&id=32c4b680"
import script from "./ListaRilevazioni.vue?vue&type=script&lang=js"
export * from "./ListaRilevazioni.vue?vue&type=script&lang=js"
import style0 from "./ListaRilevazioni.vue?vue&type=style&index=0&id=32c4b680&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports